<template>
    
    <div class="offerList">
        <div class="sectionHeader" v-if="showHeader">
            <div class="isFixed">
                <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
            </div>
        </div>
        <backView :backTitle="'报价列表'" :showHeader="showHeader"></backView>
        <noData v-if="nodateShow" :dataTitle="'暂无数据'" :noDataStyle="noDataStyle"></noData>
        <offerListCom v-if="!nodateShow" @repealOffer="repealOffer" @delOffer="delOffer" :data="offerListData" @loadingList="loadingList"></offerListCom>
        <noData v-if="nomoreShow" :dataTitle="'没有更多了'" :noDataStyle="noMoreStyle"></noData>
        <back-to-top transitionName="fade" :customStyle="myBackToTopStyle"  :iconColor="myBackToTopStyleIconColor"
            :visibilityHeight="300" :backPosition="0">
        </back-to-top>
        <repealCom :repealShow="repealShow" :repealComData="repealComData" @repealBtn="repealBtn" 
            @delBtn="delBtn" :clickOfferData="clickOfferData"
            @noneRepeal="noneRepeal"></repealCom>
        <Login :show="showLogin" @click="loginPopClick"></Login>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import mainHeader from '@/view/header'
import backView from './components/backView.vue'
import offerListCom from './components/offerListCom.vue'
import backToTop from './components/backToTop'
import noData from "./components/noData.vue"
import repealCom from "./components/repeal.vue"
import Login from './../shopping/goods/pop-login.vue'
import { createNamespacedHelpers, mapGetters, mapActions as mapOtherActions, mapState as mapOtherState, } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("procurement");
import "./assets/index.css"
export default {
    name:'offerList',
    inject: ['reload'], // 界面刷新
    components: {
        mainHeader,backView,offerListCom,backToTop,noData,repealCom,Login
    },
    data () {
        return {
            showLogin : false,
            repealShow : false,
            nodateShow : false,
            nomoreShow : false,
            repealComData : {
                type : "",
                title : "",
                text : ""
            },
            noDataStyle : {
                "margin-top" : "30px"
            },
            noMoreStyle : {
                "margin-top" : "5px",
                "padding-bottom" : "20px"
            },
            myBackToTopStyle: {
                'right': '15px',
                'bottom': '90px',
                'width': '40px',
                'height': '40px',
                'border-radius': '20px',
                'line-height': '40px', 
                'background': '#C41335',
                "color" : "#ffffff"
            },
            myBackToTopStyleIconColor : {
                "color" : "#ffffff"
            },
            
            offerListData : {},
            clickOfferData : {},
            showHeader : false,
            tabHeight : 0,

            
        }
    },
    created () {
        if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1||this.$route.query.isApp == 2 || localStorage.getItem('isApp') == 2) {
            this.showHeader = false
            } else {
            this.showHeader = true
            }
            if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
            var _this = this
            window['androidTabHeight'] = (result) => {
                _this.androidTabHeight(result)
            }
            if (this.utils.isIphone() === true) {
                this.androidTabHeight('0')
            } else {
                this.androidTabHeight(window.zxzx.getNavigationBarHeight())
            }
            }
    },
    computed:{
        ...mapState(['wantOfferList']),
    },
    methods: {
        ...mapActions(["getWantOfferList","wantOfferCancelOffer",,"wantOfferDeleteByIds","getWantOfferLeftOfferTimes"]),
        androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(value)
      }
    },
        loadingList(getParams){
            this.getWantOfferList(JSON.parse(getParams)).then(res=>{
                if(res.success){
                    this.offerListData = res.data;
                    if(this.offerListData.paginate.page==1&&this.offerListData.paginate.rows.length==0){
                        this.nodateShow =true
                    }
                }
            })
        },
         logoutClick: function () { // 退出登录  刷新界面
            this.reload()
        },
        delOffer(val){
            this.repealComData = {
                type : "del",//repeal del 
                title : "您确定删除吗？",
                text : "删除之后报价单无法恢复"
            };
            this.clickOfferData = JSON.parse(val)
            this.repealShow = true
        },
        noneRepeal(){
             this.repealShow = false
        },
        repealOffer(val){
            this.repealComData = {
                type : "repeal",//repeal del 
                title : "您确定撤销吗？",
                text : "一旦撤销将无法正常查看您的报价",
                count : 0
            };
            this.clickOfferData = JSON.parse(val)
            this.getWantOfferLeftOfferTimes({id:this.clickOfferData.want_buy_id}).then(res=>{
                this.repealComData.count = res.data
                this.repealShow = true
            })
        },
        repealBtn(val){//点击删除确认和取消按钮
            let offerDetail = JSON.parse(val)
            this.wantOfferCancelOffer({ids:offerDetail.id}).then(res=>{
                this.repealShow = false;
                if(res.success&&res.code==0){
                    this.Toast("撤销成功")
                    setTimeout(()=>{
                        this.logoutClick()
                    },1500)
                }
            })
        },
        delBtn(val){//点击删除确认和取消按钮
            let offerDetail = JSON.parse(val)
            this.wantOfferDeleteByIds({ids:offerDetail.id,type:1}).then(res=>{
                this.repealShow = false;
                if(res.success&&res.code==0){
                    this.Toast("删除成功")
                    setTimeout(()=>{
                        this.logoutClick()
                    },1500)
                }
                // else{
                //     this.Toast(res.message)
                // }
            })
        },
        logoutClick: function () { // 退出登录  刷新界面
            this.reload()
        },
        loginPopClick: function (type) { // 0 隐藏 1 登录成功 2 注册 3 忘记密码
            this.showLogin = false
            if (type === 1) {
                this.isLogin = 1
                this.logoutClick();
            }
            if (type === 2) {
                this.$router.push({ path: 'register' })
            }
            if (type === 3) {
                this.$router.push({ path: 'retrieve' })
            }
        },
        checkLogin () {
          this.utils.get(this.companyUrl + '/ent/json', null, res => {
                localStorage.setItem('userinfo', JSON.stringify(res.data))
            })
        }
    },
    mounted () {
        var _this = this
        this.utils.isUserLogin(function (login) {
        if (login === 0) {
            _this.isLogin = 0;
            _this.showLogin = true;
        } else {
            _this.isLogin = 1
            _this.checkLogin()
        }
        })
    },
}

</script>


<style lang='scss' scoped>
.offerList{
    background: #eee;
    min-height: 100vh;
}
.sectionHeader {
  height: 55px;
  width: 100%;
  z-index: 900;
}
.sectionHeader .isFixed {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 900;
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/offerList.vue